export default __webpack_public_path__ + "static/media/books2-afterA-2048w.a077ccb6.webp";